var React = require('react');

function IconOpen (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M616.47,152.23l7.59-4.38-162-93.55-150,86.62h0l0,0L162,54.3,0,147.85l.17.09h0l155.91,90V411.11l156,90.08,156-90.07V237.91ZM174.06,234.44l76.13-43.95,55.88-32.23v152.4Zm426-86.59-138,79.65-138-79.66,138-79.68ZM161.82,68.26,300,147.88l-55.86,32.25L162,227.5,24.15,147.93Zm156.25,90,132,76.14-132,76.22Zm-150,86.57,138,79.65V483.86l-138-79.68Zm288,159.32-138,79.68V324.52l138-79.68Z","fill":"#32cb87","key":1})]);
}

IconOpen.defaultProps = {"id":"Open_v02","data-name":"Open v02","viewBox":"0 0 624.06 545.23"};

module.exports = IconOpen;

IconOpen.default = IconOpen;
